import { render, staticRenderFns } from "./group-status-form.vue?vue&type=template&id=3004e006"
import script from "./group-status-form.vue?vue&type=script&lang=js"
export * from "./group-status-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports